export default class home_general {
  constructor() {

  }

  checkLogo(){
    if(window.localStorage.getItem('note-home-biglogo')){
      var diff = (Date.now() - parseInt(window.localStorage.getItem('note-home-biglogo'))) / 1000;
      console.log(diff);
      let fivemin = 300;
      if(diff > fivemin) {
        console.log('has passed');
        this.doLogo();
      } else {
        console.log('hasnt passed');
      }
    } else if (window.localStorage.getItem('note-home-splash')){
    }
  }

  doLogo(){
    $('.header').addClass('notrans huge').css('opacity',1);
    setTimeout(function(){
      $('.header').removeClass('notrans');
    }, 300);
  }

  checkSplash(){
    console.log('checked home splash');
    var doHomeSplash;

    if(window.localStorage.getItem('note-home-splash')){
      var diff = (Date.now() - parseInt(window.localStorage.getItem('note-home-splash'))) / 1000;
      let month = 86400*30;
      if(diff < month) {
        if(!window.homeconstructed&&!window.home3dconstructed) {
          $('.splashtext').remove();
          $('.menu-button').addClass('noanim');
          window.home.doAnimation();
        }
      } else {
        // been a month
        this.doSplash();
      }
    } else {
      console.log('doing splash');
      this.doSplash();
    }
  }

  doSplash(){
    var home = this;

    home.doLogo();

    $('.menu-button').addClass('anim');

    var splashItems = $('.splashtext').children();

    for(var s=0;s<splashItems.length;s++){
      var words = $(splashItems[s]).text().split(' ');
      var str = '';
      for(var w = 0;w<words.length;w++){
        str += '<span>'+words[w]+'</span> ';
      }
      $(splashItems[s]).html(str);
    }

    setTimeout(function(){
      for(let i=0; i<splashItems.length;i++){
        setTimeout(function(){
          if(i>0){
            var prevSpans = $(splashItems[i-1]).children();
            $(prevSpans).addClass('out');
            $(splashItems[i]).addClass('in');
          } else {
            $(splashItems[i]).addClass('in');
          }
          if(i==splashItems.length-1) {
            setTimeout(function(){
              setTimeout(function(){
                $(splashItems[i]).removeClass('in').addClass('out');
                if($('html').hasClass('home3d') && window.doflashtitle){
                  if(window.home.scene.modelsLoaded) {
                    window.home.scene.doFlashTitle();
                  }
                }
              }, 500);
              console.log('done');
              window.home.doAnimation();
              window.localStorage.setItem('note-home-splash', Date.now());
            }, 1600);
          }
        }, 1600 * i);
      }
    }, 1000);
  }

  runNotis(){
    window.notisInTimeoutNews = [];
    if(window.localStorage.getItem('note-notis-folded')==null) {

      if($('.noti.news').length>0){
        window.notisInTimeout = setTimeout(function(){
          window.notisInTimeoutNews[0] = setTimeout(function(){
            $('.notis--toggle').addClass('in');
          }, 300);

          $('.noti.news').each(function(idx){
            var t = $(this);
            window.notisInTimeoutNews[idx+1] = setTimeout(function(){
              $(t).addClass('in');
            }, 500 + (500 * idx));
          });
        }, 3000);
      }
    } else if (window.localStorage.getItem('note-notis-folded')!='yes') {
      $('.notis').slideDown(300);
      if($('.noti.news').length>0){
        window.notisInTimeoutNews[0] = setTimeout(function(){
          $('.notis--toggle').addClass('in');
        }, 300);

        $('.noti.news').each(function(idx){
          var t = $(this);
          window.notisInTimeoutNews[idx+1] = setTimeout(function(){
            $(t).addClass('in');
          }, 500 + (500 * idx));
        });
      }

    } else {
      // noti folded cookie
      $('.notis').slideDown(300);
      if($('.noti.news').length>0){
        $('.notis--toggle').addClass('togd in');
      }
    }

    $('.noti.news').unbind('mouseenter mouseleave').mouseenter(function(){
      $(this).find('.noti--inner--link').slideDown(100);
    }).mouseleave(function(){
      $(this).find('.noti--inner--link').slideUp(100);
    });

    $('.notis--toggle').unbind('click').click(function(e){
      e.preventDefault();
      $(this).toggleClass('togd');
      $('.noti.news').each(function(idx){
        var t = $(this);
        clearTimeout(this.to);
        this.to = setTimeout(function(){
          $(t).toggleClass('in');
        }, (100 * idx));
      });
      var val = $(this).hasClass('togd') ? 'yes' : 'no';
      window.localStorage.setItem('note-notis-folded',val);
    });
  }
}
